/* avkit.js — Sivena cloned-content runtime (no inline scripts allowed on these stores)
   - reveals scroll-hidden content (no IntersectionObserver in source clone)
   - rebuilds Swiper/Splide carousels as flex scroll-snap rows + wires arrows/dots
   - makes content-tabs work (one panel visible, click swaps) if present
   - floating sticky CTA -> smooth-scroll to #av-offer
   - every .av CTA link/button -> scroll to #av-offer (carousel controls excepted) */
(function () {
  "use strict";
  var OFFER = "#av-offer";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function offerEl() { return document.getElementById("av-offer"); }
  function scrollToOffer() {
    var el = offerEl();
    if (el) { el.scrollIntoView({ behavior: "smooth", block: "center" }); return true; }
    var form = document.querySelector('product-form, form[action*="/cart/add"], [id*="ProductSubmitButton"], .product-form');
    if (form) { form.scrollIntoView({ behavior: "smooth", block: "center" }); return true; }
    return false;
  }

  /* ---------------- reveal hidden content ---------------- */
  function reveal() {
    document.querySelectorAll(".av").forEach(function (root) {
      root.classList.add("av-revealed", "is-visible");
      root.querySelectorAll("*").forEach(function (n) {
        var s = n.getAttribute && n.getAttribute("style");
        if (s && /opacity\s*:\s*0|visibility\s*:\s*hidden|translate|transform\s*:/.test(s)) {
          n.style.opacity = "1";
          n.style.visibility = "visible";
          n.style.transform = "none";
        }
        if (n.classList) {
          ["is-hidden", "reveal", "av-reveal", "pre-reveal", "not-visible"].forEach(function (c) {
            if (n.classList.contains(c)) n.classList.remove(c);
          });
          if (/reveal|fade|animate/i.test(n.className) && !/revealed/i.test(n.className)) {
            n.classList.add("is-visible", "is-inview", "av-shown");
          }
        }
      });
    });
  }

  /* ---------------- carousels (flex scroll-snap + arrows/dots) ---------------- */
  function wireScroller(viewport, cards, prev, next, dots) {
    if (!viewport || !cards.length) return;
    function step() {
      if (cards.length < 2) return cards[0].offsetWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }
    function current() {
      return Math.max(0, Math.min(cards.length - 1, Math.round(viewport.scrollLeft / (step() || 1))));
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      viewport.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: "smooth" });
      setActive(i);
    }
    function setActive(i) {
      if (dots) dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); });
    }
    if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); go(current() - 1); });
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); go(current() + 1); });
    if (dots) dots.forEach(function (d, k) {
      d.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); go(k); });
    });
    var ticking = false;
    viewport.addEventListener("scroll", function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { setActive(current()); ticking = false; });
    }, { passive: true });
  }

  function carousels() {
    // sec12 — video stories
    document.querySelectorAll(".av .avs-stories").forEach(function (s) {
      wireScroller(
        s.querySelector(".avs-stories__viewport"),
        Array.prototype.slice.call(s.querySelectorAll(".avs-video-card")),
        s.querySelector(".avs-stories__prev"),
        s.querySelector(".avs-stories__next"),
        Array.prototype.slice.call(s.querySelectorAll(".avs-stories__dots button"))
      );
    });
    // sec10 — reasons
    document.querySelectorAll(".av .av-reasons").forEach(function (s) {
      var vp = s.querySelector('[class*="viewport"]') || s.querySelector('[class*="track"]');
      var cards = Array.prototype.slice.call(s.querySelectorAll('[class*="track"] > *'));
      var arrows = Array.prototype.slice.call(s.querySelectorAll('[class*="prev"],[class*="next"],[class*="arrow"]'));
      wireScroller(vp, cards, arrows[0], arrows[arrows.length - 1],
        Array.prototype.slice.call(s.querySelectorAll('[class*="dots"] button')));
    });
    // sec04 — review progress dots scroll the review row
    document.querySelectorAll(".av .av-review-progress").forEach(function (nav) {
      var root = nav.closest(".av") || document;
      var row = root.querySelector(".av-reviews");
      var cards = Array.prototype.slice.call(root.querySelectorAll(".av-review"));
      var dots = Array.prototype.slice.call(nav.querySelectorAll("button"));
      if (!row || !cards.length) return;
      dots.forEach(function (d, k) {
        d.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation();
          if (cards[k]) row.scrollTo({ left: cards[k].offsetLeft - cards[0].offsetLeft, behavior: "smooth" });
          dots.forEach(function (x, i) { x.classList.toggle("is-active", i === k); });
        });
      });
    });
  }

  /* ---------------- content tabs (generic) ---------------- */
  function tabs() {
    document.querySelectorAll('.av [class*="content-tabs"], .av [data-av-tabs]').forEach(function (root) {
      var btns = Array.prototype.slice.call(root.querySelectorAll('[class*="content-tabs__button"], [role="tab"], [data-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[class*="content-tab__content"], [role="tabpanel"], [data-tab-panel]'));
      if (!btns.length || !panels.length) return;
      function show(i) {
        panels.forEach(function (p, k) { p.style.display = k === i ? "" : "none"; });
        btns.forEach(function (b, k) { b.classList.toggle("is-active", k === i); });
      }
      btns.forEach(function (b, i) {
        b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); show(i); });
      });
      show(0);
    });
  }

  /* ---------------- CTA links/buttons -> offer ---------------- */
  var CONTROL = [
    ".avs-stories__arrow", ".avs-stories__dots button", ".av-review-progress button",
    '[class*="__arrow"]', '[class*="__prev"]', '[class*="__next"]',
    '[class*="-arrow"]', '[class*="-prev"]', '[class*="-next"]',
    '[class*="dots"] button', "summary", '[class*="content-tabs__button"]', "[data-tab]"
  ].join(",");

  function isControl(el) {
    return !!el.closest(CONTROL);
  }

  function wireCtas() {
    document.querySelectorAll(".av a, .av button").forEach(function (el) {
      if (isControl(el)) return;
      if (el.tagName === "A") {
        var href = (el.getAttribute("href") || "").trim().toLowerCase();
        if (href.indexOf("mailto:") === 0 || href.indexOf("tel:") === 0) return;
      }
      el.addEventListener("click", function (e) {
        e.preventDefault();
        scrollToOffer();
      });
    });
  }

  /* ---------------- floating sticky CTA ---------------- */
  function sticky() {
    if (!document.querySelector(".av")) return;
    var wrap = document.createElement("div");
    wrap.className = "av-sticky";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "av-sticky__btn";
    btn.innerHTML = 'PROFITER DE L’OFFRE <span class="av-sticky__arrow">→</span>';
    btn.addEventListener("click", function (e) { e.preventDefault(); scrollToOffer(); });
    wrap.appendChild(btn);
    document.body.appendChild(wrap);

    var buyInView = false;
    var buyEl = offerEl() ||
      document.querySelector('product-form, [id*="ProductSubmitButton"], button[name="add"], .product-form__submit, .product-form');
    if (buyEl && "IntersectionObserver" in window) {
      new IntersectionObserver(function (ents) {
        buyInView = ents.some(function (en) { return en.isIntersecting; });
        update();
      }, { rootMargin: "0px 0px -10% 0px" }).observe(buyEl);
    }

    function drawerOpen() {
      if (document.body.classList.contains("drawer-open") ||
          document.body.classList.contains("js-drawer-open") ||
          document.body.classList.contains("overflow-hidden")) return true;
      var d = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, .drawer--cart, [class*="cart-drawer"], .mini-cart, #cart-notification');
      if (d) {
        if (d.classList && (d.classList.contains("active") || d.classList.contains("is-open") ||
            d.classList.contains("open") || d.classList.contains("drawer--is-open"))) return true;
        if (d.getAttribute && d.getAttribute("aria-hidden") === "false") return true;
        if (d.hasAttribute && d.hasAttribute("open")) return true;
      }
      return false;
    }

    function update() {
      var show = window.pageYOffset > 500 && !buyInView && !drawerOpen() && !!offerEl();
      wrap.classList.toggle("av-sticky--show", show);
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    document.addEventListener("click", function () { setTimeout(update, 60); });
    update();
  }

  ready(function () {
    try { reveal(); } catch (e) {}
    try { carousels(); } catch (e) {}
    try { tabs(); } catch (e) {}
    try { wireCtas(); } catch (e) {}
    try { sticky(); } catch (e) {}
  });
})();
